import React from 'react';
import Modal from 'react-modal';
import { DialogStore, Stores } from '../store';
import ReactMarkdown from 'react-markdown';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { Button } from './button';
import styled from '../styles/styled-components';

type DialogOwnProps = {};
type DialogStoreProps = { dialogStore: DialogStore };
type DialogProps = DialogOwnProps & DialogStoreProps;

const OverlayStyles: React.CSSProperties = {
  zIndex: 2,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

const ContentStyles: React.CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'initial',
  bottom: 'initial',
  transform: 'translate(-50%, -50%)',
  minWidth: '600px',
  padding: 0,
};

const Header = styled.h2`
  border-bottom: 1px solid ${p => p.theme.dividerColor};
  display: flex;
  padding: 20px;
  font-size: 22px;
  margin: 0;
`;

const CloseButton = styled(Button)`
  float: right;
`;

const Body = styled.div`
  padding: 25px 20px;
  display: flex;
`;

const Footer = styled.div`
  border-top: 1px solid ${p => p.theme.dividerColor};
  display: flex;
  padding: 20px;
  justify-content: flex-end;

  // TODO fix it
  button + button {
    margin-left: 7px;
  }
`;

class DialogComp extends React.Component<DialogProps, {}> {
  close = () => {
    this.props.dialogStore.closeFirstDialog();
  };
  render() {
    if (!this.state || this.props.dialogStore.dialogs.length == 0) {
      return <div style={{ display: 'none' }} />;
    }

    let { dialogs } = this.props.dialogStore;
    let dialog = dialogs[0];
    return (
      <Modal
        isOpen={dialogs.length > 0}
        onRequestClose={this.close}
        style={{ overlay: OverlayStyles, content: ContentStyles }}
      >
        <Header>
          {dialog.title}{' '}
          <CloseButton
            transparent
            icon="x"
            onClick={this.close}
            aria-label="Close"
          />
        </Header>
        <Body>{dialog.body}</Body>
        <Footer>
          <Button primary onClick={this.close} content="Close" />
        </Footer>
      </Modal>
    );
  }
}

export const Dialog = inject<Stores, DialogOwnProps, DialogStoreProps, {}>(
  ({ dialogStore }) => ({
    dialogStore,
  }),
)(observer(DialogComp)) as React.ComponentClass<DialogOwnProps>;

export interface DialogContent {
  title: string;
  body: React.ReactNode | string;
  buttons?: any[];
  onClose?: () => any;
}

//use this pattern instead of an event emitter because I want to keep type safety
export let dialogEvents = {
  /** Post a dialog. */
  dialog(content: DialogContent) {},
};
/** The dialog system that's actually being used. Call dialogEvents.dialog. */
export class Dialogs extends React.Component<
  {},
  {
    dialogs: DialogContent[];
  }
> {
  lastDialog: DialogContent;
  constructor(props) {
    super(props);
    this.state = { dialogs: [] };
  }
  componentDidMount() {
    dialogEvents.dialog = this.addDialog;
  }
  componentWillUnmount() {
    dialogEvents.dialog = () => {};
  }
  addDialog = (content: DialogContent) => {
    this.setState((prevState, props) => {
      return { dialogs: _.flatten([content, prevState.dialogs]) };
    });
  };
  closeFirstDialog() {
    let { dialogs } = this.state;
    if (dialogs[0] && dialogs[0].onClose) {
      dialogs[0].onClose();
    }
    if (dialogs.length == 1) {
      this.lastDialog = dialogs[0];
    }
    if (dialogs.length > 0) {
      this.setState({ dialogs: _.tail(dialogs) });
    }
  }
  render() {
    /*
        if (this.state.dialogs.length == 0) {
            return <div style={{display: "none"}}></div>
        }
        */

    let { dialogs } = this.state;
    let dialog = dialogs[0] || this.lastDialog; //the things I do for proper animations...
    let buttons;
    if (dialog) {
      if (dialog.buttons) {
        buttons = dialog.buttons.map(btn => {
          return React.cloneElement(btn, {
            onClick: () => {
              if (btn.props.onClick) {
                btn.props.onClick();
              }
              this.closeFirstDialog();
            },
          });
        });
      } else {
        buttons = (
          <Button onClick={() => this.closeFirstDialog()}>Close</Button>
        );
      }
    }

    return (
      <div>
        <Modal
          appElement={document.getElementById('app')}
          isOpen={dialogs.length > 0}
          onRequestClose={() => {}}
          style={{ overlay: OverlayStyles, content: ContentStyles }}
        >
          <Header>{dialog ? dialog.title : ''}</Header>
          <Body>
            {dialog ? (
              typeof dialog.body !== 'string' ? (
                dialog.body
              ) : (
                <ReactMarkdown source={dialog.body as string} />
              )
            ) : (
              ''
            )}
          </Body>
          <Footer>
            {buttons || null}
            {/* dialog? dialog.buttons.map((props, i) => {
                        return <Button {...props} key={i} onClick={() => {
                            if (typeof props.onClick == "function") {
                                props.onClick()
                            }
                            
                            this.closeFirstDialog()
                        }} />
                    }): "" */}
          </Footer>
        </Modal>
      </div>
    );
  }
}

export interface PromptDialogProps {
  body: React.ReactNode;
  confirmButtonText: string;
  cancelButtonText: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

interface PromptDialogState {
  inputValues: Record<string, string>;
}

@observer
export class PromptDialog extends React.Component<
  PromptDialogProps,
  PromptDialogState
> {
  constructor(props: PromptDialogProps) {
    super(props);
    this.state = {
      inputValues: {},
    };
  }

  render() {
    return (
      <div>
        <Modal
          appElement={document.getElementById('app')}
          isOpen={this.props.isOpen}
          style={{ overlay: OverlayStyles, content: ContentStyles }}
        >
          <Header>{this.props.title}</Header>
          <Body>{this.props.body}</Body>
          <Footer>
            {[
              <Button key="confirm" onClick={this.props.onConfirm}>
                {this.props.confirmButtonText}
              </Button>,

              <Button key="cancel" onClick={this.props.onCancel}>
                {this.props.cancelButtonText}
              </Button>,
            ]}
          </Footer>
        </Modal>
      </div>
    );
  }
}
